import { IApplicationState } from '../../../types/redux';

export const selectSubdomain = (state: IApplicationState) => state.location.subdomain || 'www';
